<template>
  <intersection-observer
    class="base-flyer-card leaflet module-card-intersection-observer"
    :active="true"
    @intersect="emitIntersect"
    @click.native="emitClick"
  >
    <div
      class="base-flyer-card__image-wrapper"
      :class="{ 'image-wrapper-fixed': aspectFit }"
    >
      <extended-image
        class="base-flyer-card__image"
        :src="image"
        css-width="100%"
        css-height="100%"
        object-fit="cover"
      />
    </div>
    <div v-if="displayDate === true" class="base-flyer-card__duration-wrapper">
      <div class="base-flyer-card__duration">{{ dateText }}</div>
    </div>
    <div class="base-flyer-card__leaflet-title-wrapper">
      <div class="base-flyer-card__leaflet-title">{{ issue }}</div>
    </div>
  </intersection-observer>
</template>

<script setup>
import ExtendedImage from '@/components/ExtendedImage'
import IntersectionObserver from '@/components/IntersectionObserver'

const runtimeConfig = useRuntimeConfig()

const props = defineProps({
  /**
   * 記事ID
   */
    id: {
    type: Number,
    required: true,
  },
  /**
   * 画像用データ
   */
  image: {
    type: String,
    required: true,
  },
  /**
   * 日付
   * {array} unix timeでくる想定
   */
  date: {
    type: Array,
    default: () => [],
  },
  /**
   * 号
   */
  issue: {
    type: String,
    default: null,
  },
  shopId: {
    type: [Number, String, null],
    default: null,
  },
  detailId: {
    type: [Number, String],
    required: true,
  },
  location: {
    type: Object,
    default: null,
  },
  aspectFit: {
    type: Boolean,
    default: false,
  },
  displayDate: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['click', 'intersect'])

const dateText = computed(() => {
  if (1 in props.date) {
    if (FORMATBY(props.date[0], 'YYYY') !== FORMATBY(props.date[1], 'YYYY')) {
      return `${FORMATBY(ADDDAY(props.date[0]), 'YYYY年M月D日')}~${FORMATBY(
        props.date[1],
        'YYYY年M月D日'
      )}まで`
    } else if (
      FORMATBY(ADDDAY(props.date[0]), 'M') !== FORMATBY(props.date[1], 'M')
    ) {
      return `${FORMATBY(ADDDAY(props.date[0]), 'YYYY年M月D日')}~${FORMATBY(
        props.date[1],
        'M月D日'
      )}まで`
    } else {
      return `${FORMATBY(ADDDAY(props.date[0]), 'YYYY年M月D日')}~${FORMATBY(
        props.date[1],
        'D日'
      )}まで`
    }
  } else if (0 in props.date) {
    return `${FORMATBY(props.date[0], 'YYYY年M月D日')}まで`
  } else {
    return null
  }
})

const hrefValue = computed(() => {
  // TODO URLは要検討
  return `${runtimeConfig.public.chirashiUrl}/${runtimeConfig.public.chainKey}/${runtimeConfig.public.paddingedChainId}/chirashi/?shop-id=${props.shopId}&detail-id=${props.detailId}`
})

const emitClick = () => {
  emit('click', { link: hrefValue.value, detailId: props.detailId })
}

const emitIntersect = () => {
  const data = {
    id: props.id,
    detailId: props.detailId,
    shopId: props.shopId,
    location: JSON.stringify(props.location),
  }
  emit('intersect', data)
}
</script>

<style lang="scss" scoped>
.base-flyer-card {
  width: 270px;
  margin: 10px 10px;
  color: #3c3c3c;
  float: left;
  text-decoration: none;
  display: block;
  font-size: 16px;
  font-family: 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', 'Meiryo',
    'メイリオ', 'Osaka', 'MS PGothic', arial, helvetica, sans-serif;
  @media screen and (min-width: 440px) {
    width: 200px;
  }
  &:hover {
    cursor: pointer;
  }
  .base-flyer-card__image-wrapper {
    text-align: center;
    @media screen and (min-width: 440px) {
      line-height: 1.5;
    }
  }
  .image-wrapper-fixed {
    img {
      object-position: top;
      height: 180px !important;
      width: 270px !important;
      @media screen and (min-width: 440px) {
        height: 140px !important;
        width: 210px !important;
      }
    }
  }
  .base-flyer-card__image {
    vertical-align: baseline;
  }
  .base-flyer-card__duration-wrapper {
    text-align: center;
    @media screen and (min-width: 440px) {
      line-height: 1.5;
    }
  }
  .base-flyer-card__duration {
    font-size: 79%;
    line-height: 12px;
    display: inline-block;
  }
  .base-flyer-card__leaflet-title-wrapper {
    text-align: center;
    @media screen and (min-width: 440px) {
      line-height: 1.5;
    }
  }
  .base-flyer-card__leaflet-title {
    font-size: 79%;
    line-height: 12px;
    display: inline-block;
  }
}
</style>
